import { CTAForm, InlineLink, FormControl, TextInput, Checkbox, Text } from '@primer/react-brand';
import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  CTAForm,
  InlineLink,
  FormControl,
  TextInput,
  Checkbox,
  Text,
  ComponentLayout,
  React
};